var swatchesRow = document.querySelector('.product_swatch');
if (swatchesRow) {
    document.addEventListener('change', function (e) {
        var el = e.target;
        if (el.classList.contains('product_swatch_radio')) {
            var val = el.value;
            var optionDropdownId = el.getAttribute('data-selectid');
            var parent = el.closest('.product__info-container');
            if (parent) {
                var optionDropdown = parent.querySelector('#' + optionDropdownId);
                if (optionDropdown) {
                    optionDropdown.value = val;
                    optionDropdown.dispatchEvent(new Event('change', {
                        bubbles: true
                    }));
                }
            }
        }
    });

}
var doubleButton = document.querySelector('.double-button');
if (doubleButton) {
    document.addEventListener('click', function (e) {
        var el = e.target;
        if (el.classList.contains('double-button') || el.closest('.double-button')) {
            if (!el.classList.contains('double-button')) {
                el = el.closest('.double-button');
            }
            e.preventDefault();
            el.querySelector('form').dispatchEvent(new Event('submit', {
                bubbles: true
            }));
        }
    });
}

var thumbGallery = document.querySelectorAll('.product__thumb-list .product__thumb-item');
if (thumbGallery.length) {
    thumbGallery.forEach(function (item, index) {
        item.addEventListener('click', function (e) {
            e.preventDefault();
            var itemId = this.getAttribute('data-media-id');
            var prevActiveThumb = this.parentNode.querySelector('.active_thumb');
            if (prevActiveThumb) {
                prevActiveThumb.classList.remove('active_thumb');
            }
            this.classList.add('active_thumb');
            var mainGalleryItems = document.querySelectorAll('.product__media-wrapper .product__media-item');
            if (mainGalleryItems.length) {
                mainGalleryItems.forEach(function (media, index) {
                    var mediaElId = media.getAttribute('data-mediaId');
                    if (itemId == mediaElId) {
                        var parent = media.parentElement;
                        parent.prepend(media);
                    }
                });
            }
        });
    });
}

class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('change', this.onVariantChange);
    }

    onVariantChange(event) {
        this.updateOptions();
        this.updateMasterId();
        
        // Dawn compatibility: Publish PubSub event for product-info.js
        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
            const target = event?.target;
            if (target) {
                publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
                    data: {
                        event,
                        target,
                        selectedOptionValues: this.selectedOptionValues || [],
                    },
                });
            }
        }
        
        // Dawn compatibility: Also publish variant change event
        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined' && this.currentVariant) {
            publish(PUB_SUB_EVENTS.variantChange, {
                data: {
                    sectionId: this.dataset.section,
                    html: null,
                    variant: this.currentVariant,
                },
            });
        }
        
        this.toggleAddButton(true, '', false);
        this.updatePickupAvailability();

        if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
        } else {
            this.updateMedia();
            this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo();
        }
    }

    updateOptions() {
        // Handle both select dropdowns and radio/button inputs (Dawn compatibility)
        const fieldsets = this.querySelectorAll('fieldset');
        const selects = this.querySelectorAll('select');
        
        if (fieldsets.length > 0) {
            // Dawn uses fieldsets with radio inputs for swatches/buttons
            this.options = Array.from(fieldsets, (fieldset) => {
                const checkedInput = fieldset.querySelector('input:checked');
                return checkedInput ? checkedInput.value : '';
            });
        } else if (selects.length > 0) {
            // Traditional select dropdowns
            this.options = Array.from(selects, (select) => select.value);
        } else {
            this.options = [];
        }
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            let checkVariant = document.querySelector('.sale-flag.product_tag_icon');
            if (variant.compare_at_price) {
                if (checkVariant) {
                    document.querySelector('.sale-flag.product_tag_icon').style.display = 'block';
                }

            } else {
                if (checkVariant) {
                    document.querySelector('.sale-flag.product_tag_icon').style.display = 'none';
                }
            }
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });
    }

    updateMedia() {
        if (!this.currentVariant || !this.currentVariant?.featured_media) return;
        const newMedia = document.querySelector(
            `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
        );

        if (!newMedia) return;
        const parent = newMedia.parentElement;
        parent.prepend(newMedia);

        var product_parent = parent.closest('.product');
        var featured_mediaID = this.currentVariant.featured_media.id;

        if (product_parent) {
            var thumbGallery = product_parent.querySelectorAll('.product__thumb-list .product__thumb-item');
            if (thumbGallery.length) {
                thumbGallery.forEach(function (item, index) {
                    var itemId = item.getAttribute('data-media-id');

                    if (featured_mediaID == itemId) {
                        item.classList.add('active_thumb');

                    } else {
                        item.classList.remove('active_thumb');
                    }
                });
            }
        }

        window.setTimeout(() => {
            parent.scroll(0, 0)
        });
    }

    updateURL() {
        if (!this.currentVariant) return;
        //         window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');

            // ??
            if (this.currentVariant.id == 41432154112057) {
                input.value = 40363289706553;

            } else if (this.currentVariant.id == 41432154079289) {
                input.value = 40363289739321;

            } else {
                input.value = this.currentVariant.id;
            }

            input.dispatchEvent(new Event('change', {
                bubbles: true
            }));

        });
    }

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;

        if (this.currentVariant?.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }

    renderProductInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&#${this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                const id = `price-${this.dataset.section}`;
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const destination = document.getElementById(id);
                const source = html.getElementById(id);

                if (source && destination) destination.innerHTML = source.innerHTML;

                document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');

                if (this.getAttribute('data-coming-soon') == 'true') {
                    this.toggleAddButton(!this.currentVariant.available, window.strings.coming_soon);
                } else {
                    this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
                }

                // Updated additional product price for HiRise 3 + PlugBug Slim
                if (document.querySelector(".hirise-3-wireless-select")) {
                    let selectElement = document.querySelector(".hirise-3-wireless-select"),
                        selectedOption = selectElement.value,
                        selectedIndex = selectElement.selectedIndex,
                        selectedCurrentOption = selectElement.options[selectedIndex],
                        dataPrice = selectedCurrentOption.getAttribute('data-price');

                    document.querySelector('.price__regular span.money').innerText = '$' + dataPrice;
                }
                // End Updated additional product price for HiRise 3 + PlugBug Slim
            });
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
        const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');

        if (!addButton) return;

        var coming_soon_flag = false;
        var data_pre_order_flag = false;
        var data_pre_order_date = '';
        var variants_infoSelect = document.getElementById(`variants_info-${this.dataset.section}`);

        if (variants_infoSelect) {
            var variants_select_options = variants_infoSelect.querySelectorAll('option');
            if (variants_select_options.length) {

                if (this.currentVariant) {
                    var currentVariantId = this.currentVariant.id;

                    variants_select_options.forEach(function (item, index) {
                        if (item.value == currentVariantId) {

                            if (item.getAttribute('data_pre_order_flag') == "YES") {
                                data_pre_order_flag = true;
                            }

                            if (item.getAttribute('data_pre_order_date') != undefined) {
                                if (item.getAttribute('data_pre_order_date').length) {
                                    var pre_order_dateEl = document.querySelector('.pre_order_date span');
                                    if (pre_order_dateEl) {
                                        pre_order_dateEl.innerHTML = item.getAttribute('data_pre_order_date');
                                        document.querySelector('.pre_order_date').classList.remove('hide');
                                    }
                                }
                            }

                            coming_soon_flag = item.getAttribute('data-coming_soon_flag');
                            var inventory_qty = +(item.getAttribute('data-inventory_quantity'));
                            var variant_qty_textEl = document.querySelector('.variant_qty_text');
                            if (variant_qty_textEl) {
                                if (inventory_qty > 0) {
                                    variant_qty_textEl.classList.remove('hide');
                                } else {
                                    variant_qty_textEl.classList.add('hide');
                                }
                                variant_qty_textEl.innerHTML = 'Only ' + inventory_qty + ' remaining!';
                            }
                        }
                    });
                }
            }
        } else {
          var preOrderInput = document.getElementById('pre_order_date_properties');

          if (preOrderInput) {
            data_pre_order_flag = true;
          }
        }

        var buttonParent = addButton.closest('.double-button');
        var product_notifyMe__Wrapper = document.querySelector('.product_notifyMe__Wrapper');
        var notifyMeButton = document.querySelector('.product-main-info .product__info-container .swym-button-bar.swym-wishlist-button-bar.swym-inject.swym-isa-button-bar .swym-btn-container .swym-button');

        if (notifyMeButton && this.currentVariant) {
            if (this.currentVariant.available) {
                notifyMeButton.style.display = 'none';
            } else {
                notifyMeButton.style.display = 'block';
            }
        }

        if (product_notifyMe__Wrapper && this.currentVariant) {
            if (this.currentVariant.available) {
                product_notifyMe__Wrapper.classList.remove('show_btn');
            } else {
                product_notifyMe__Wrapper.classList.add('show_btn');
            }
        }

        if (disable) {
            if (buttonParent) {
                buttonParent.classList.add('disabled');
            }
            addButton.setAttribute('disabled', true);
            if (text) addButton.querySelector('span').textContent = text;

        } else {
            addButton.removeAttribute('disabled');

            if (data_pre_order_flag) {
                // addButton.querySelector('span').textContent = window.strings.pre_order;
                addButton.textContent = window.strings.pre_order;
                var pre_order_dateEl = document.querySelector('.pre_order_date');

                if (pre_order_dateEl) {
                    pre_order_dateEl.classList.remove('hide');
                }

                var nav_buy_nowEl = document.querySelector('.nav-buy-now');
                if (nav_buy_nowEl) {
                    nav_buy_nowEl.classList.remove('hide_form');
                }

                nav_buy_nowEl.querySelector('.nav-anchor-link').innerHTML = `<span>Pre-Order <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
  <path d="M5.25 17C4.8375 17 4.48438 16.8531 4.19063 16.5594C3.89688 16.2656 3.75 15.9125 3.75 15.5C3.75 15.0875 3.89688 14.7344 4.19063 14.4406C4.48438 14.1469 4.8375 14 5.25 14C5.6625 14 6.01562 14.1469 6.30937 14.4406C6.60313 14.7344 6.75 15.0875 6.75 15.5C6.75 15.9125 6.60313 16.2656 6.30937 16.5594C6.01562 16.8531 5.6625 17 5.25 17ZM12.75 17C12.3375 17 11.9844 16.8531 11.6906 16.5594C11.3969 16.2656 11.25 15.9125 11.25 15.5C11.25 15.0875 11.3969 14.7344 11.6906 14.4406C11.9844 14.1469 12.3375 14 12.75 14C13.1625 14 13.5156 14.1469 13.8094 14.4406C14.1031 14.7344 14.25 15.0875 14.25 15.5C14.25 15.9125 14.1031 16.2656 13.8094 16.5594C13.5156 16.8531 13.1625 17 12.75 17ZM4.6125 5L6.4125 8.75H11.6625L13.725 5H4.6125ZM3.9 3.5H14.9625C15.25 3.5 15.4688 3.62813 15.6188 3.88438C15.7688 4.14062 15.775 4.4 15.6375 4.6625L12.975 9.4625C12.8375 9.7125 12.6531 9.90625 12.4219 10.0438C12.1906 10.1813 11.9375 10.25 11.6625 10.25H6.075L5.25 11.75H14.25V13.25H5.25C4.6875 13.25 4.2625 13.0031 3.975 12.5094C3.6875 12.0156 3.675 11.525 3.9375 11.0375L4.95 9.2L2.25 3.5H0.75V2H3.1875L3.9 3.5Z" fill="white"></path>
</svg></span>`;

                var pre_order_propertyEl = document.querySelector('.pre_order_property');
                if (pre_order_propertyEl) {
                    var inputPropertyEl = document.createElement('input');
                    inputPropertyEl.setAttribute('id', 'pre_order_date_properties');
                    inputPropertyEl.setAttribute('type', 'hidden');
                    inputPropertyEl.setAttribute('name', 'properties[Pre Order]');
                    inputPropertyEl.setAttribute('data-additional_text', '' + window.strings.pre_order_date);
                    inputPropertyEl.value = data_pre_order_date;
                    pre_order_propertyEl.innerHTML = ' ';
                    pre_order_propertyEl.appendChild(inputPropertyEl);
                }

            } else {
              
              var pre_order_dateEl = document.querySelector('.pre_order_date');
              if (pre_order_dateEl) {
                  pre_order_dateEl.classList.add('hide');
              }

              var navAnchorLinkElement =  document.querySelector('.nav-buy-now .nav-anchor-link');

              if (navAnchorLinkElement) {
                navAnchorLinkElement.innerHTML = `<span>Add to Cart <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                <path d="M5.25 17C4.8375 17 4.48438 16.8531 4.19063 16.5594C3.89688 16.2656 3.75 15.9125 3.75 15.5C3.75 15.0875 3.89688 14.7344 4.19063 14.4406C4.48438 14.1469 4.8375 14 5.25 14C5.6625 14 6.01562 14.1469 6.30937 14.4406C6.60313 14.7344 6.75 15.0875 6.75 15.5C6.75 15.9125 6.60313 16.2656 6.30937 16.5594C6.01562 16.8531 5.6625 17 5.25 17ZM12.75 17C12.3375 17 11.9844 16.8531 11.6906 16.5594C11.3969 16.2656 11.25 15.9125 11.25 15.5C11.25 15.0875 11.3969 14.7344 11.6906 14.4406C11.9844 14.1469 12.3375 14 12.75 14C13.1625 14 13.5156 14.1469 13.8094 14.4406C14.1031 14.7344 14.25 15.0875 14.25 15.5C14.25 15.9125 14.1031 16.2656 13.8094 16.5594C13.5156 16.8531 13.1625 17 12.75 17ZM4.6125 5L6.4125 8.75H11.6625L13.725 5H4.6125ZM3.9 3.5H14.9625C15.25 3.5 15.4688 3.62813 15.6188 3.88438C15.7688 4.14062 15.775 4.4 15.6375 4.6625L12.975 9.4625C12.8375 9.7125 12.6531 9.90625 12.4219 10.0438C12.1906 10.1813 11.9375 10.25 11.6625 10.25H6.075L5.25 11.75H14.25V13.25H5.25C4.6875 13.25 4.2625 13.0031 3.975 12.5094C3.6875 12.0156 3.675 11.525 3.9375 11.0375L4.95 9.2L2.25 3.5H0.75V2H3.1875L3.9 3.5Z" fill="white"></path>
              </svg></span>`;
              }

              if (addButton.querySelector('span')) {
                addButton.querySelector('span').textContent = window.variantStrings.addToCart;
              } else {
                document.querySelector('.double-button .product-form__submit').textContent = window.variantStrings.addToCart;
              }
              
            }

            if (buttonParent) {
                buttonParent.classList.remove('disabled');
            }
        }
        if (!modifyClass) return;
    }

    setUnavailable() {
        const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
        if (!addButton) return;
        addButton.querySelector('span').textContent = window.variantStrings.unavailable;
        document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
    }

    getVariantData() {
        if (this.variantData) return this.variantData;
        
        // Look for the variants array script tag (not the selected variant one)
        const scripts = this.querySelectorAll('[type="application/json"]');
        for (const script of scripts) {
            if (!script.hasAttribute('data-selected-variant')) {
                try {
                    this.variantData = JSON.parse(script.textContent);
                    if (Array.isArray(this.variantData)) {
                        return this.variantData;
                    }
                } catch (e) {
                    console.error('Error parsing variant data:', e);
                }
            }
        }
        
        // Fallback to empty array if no valid data found
        return [];
    }
    
    // Dawn compatibility: getter for selected option values
    get selectedOptionValues() {
        // Return array of selected option value IDs for Dawn compatibility
        const fieldsets = this.querySelectorAll('fieldset');
        const selects = this.querySelectorAll('select');
        
        if (fieldsets.length > 0) {
            return Array.from(fieldsets, (fieldset) => {
                const checkedInput = fieldset.querySelector('input:checked');
                return checkedInput?.dataset.optionValueId || '';
            }).filter(Boolean);
        } else if (selects.length > 0) {
            return Array.from(selects, (select) => {
                const selectedOption = select.options[select.selectedIndex];
                return selectedOption?.dataset.optionValueId || '';
            }).filter(Boolean);
        }
        
        return [];
    }
}

// Only define if not already registered
if (!customElements.get('variant-selects')) {
    customElements.define('variant-selects', VariantSelects);
}

class VariantRadios extends VariantSelects {
    constructor() {
        super();
    }

    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
    }

    // AirFly: Flikity
    updateMedia() {
        return;
    }
}

// Only define if not already registered
if (!customElements.get('variant-radios')) {
    customElements.define('variant-radios', VariantRadios);
}